var React = require('react');

function Erroricon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E5E5E5"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm1 10v2h-2v-2h2zm0-8v7h-2V7h2z","transform":"translate(-237 -494) translate(221) translate(16 170) translate(0 324)"})))))));
}

Erroricon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Erroricon;

Erroricon.default = Erroricon;
